export { Modal, type ModalProps } from './Modal';
